import { gql } from '@apollo/client'

export const CREATE_SAVE_PAYMENT_METHOD = gql`
    mutation b2c_save_payment_method($shopper_email: String!, $shopper_locale: String!, $top_level_domain: String!) {
        b2c_save_payment_method(
            shopper_email: $shopper_email
            shopper_locale: $shopper_locale
            top_level_domain: $top_level_domain
        ) {
            session_data
            session_id
        }
    }
`
